export default "__VITE_ASSET__06c4c95a__"